import { useRegisterSW } from 'virtual:pwa-register/react'
import { isNative } from '../platform/native.ts'

/** The PWA service worker, registered here and only here, and whether a newer shell waits ("update available"). The native app (M19b) carries its
 *  bundle inside the app: no service worker is registered there (it would only keep an older bundle beside the one the app ships with). Which of
 *  the two is decided once, when the module loads, so every render calls the same hooks. Its own module (M23-0) because the virtual import cannot
 *  be resolved outside Vite's build: a unit test of the shell (ui/Layout.test.tsx) stands this module in. */
export const useServiceWorker: () => { needRefresh: boolean; update(): void } = isNative()
  ? () => ({ needRefresh: false, update: () => undefined })
  : () => {
      const { needRefresh: [needRefresh], updateServiceWorker } = useRegisterSW()
      return { needRefresh, update: () => void updateServiceWorker(true) }
    }
